import React from 'react';
import { ordersApi } from '@/services/api';
import { formatCurrency } from '@/utils/formatters';
import { InProgressBuyOrder, InProgressSellOrder } from '@/components/orders/types';
import { fmt, pair } from './orderUtils';
import BaseProcessedInstructions from '@/components/orders/BaseProcessedInstructions';
import styles from '@/components/orders/OrderManagement.module.css';

interface ProcessedInstructionsProps {
  onDeleteSuccess: () => void;
}

const ProcessedInstructions: React.FC<ProcessedInstructionsProps> = ({ onDeleteSuccess }) => (
  <BaseProcessedInstructions<InProgressBuyOrder, InProgressSellOrder>
    fetchBuyOrders={() => ordersApi.getProcessedBuyInstructions()}
    fetchSellOrders={() => ordersApi.getProcessedSellInstructions()}
    deleteBuyOrders={(data) => ordersApi.deleteBuyOrders(data)}
    deleteSellOrders={(data) => ordersApi.deleteSellOrders(data)}
    onDeleteSuccess={onDeleteSuccess}
    buyOrderTypeColumn={{
      header: 'Order Type',
      getValue: (order) => order.order_type_display ?? '—',
    }}
    sellOrderTypeColumn={{
      header: 'Order Type',
      getValue: (order) => order.order_type_display ?? '—',
    }}
    renderBuyHeaders={() => (
      <>
        <th className={styles.num}>Limit Price</th>
        <th className={styles.num}>Max Hold %</th>
        <th className={styles.num}>Min Order Val</th>
        <th className={styles.num}>CL1 / CL2</th>
        <th className={styles.num}>Inc To 1/2</th>
        <th className={styles.num}>Inc Max 1/2</th>
        <th className={styles.num}>Inc By 1/2</th>
        <th>Buy Method</th>
      </>
    )}
    renderSellHeaders={() => (
      <>
        <th className={styles.num}>H1 / H2</th>
        <th className={styles.num}>Cond 1/2</th>
        <th className={styles.num}>Min Order Val</th>
        <th>Sell Method</th>
      </>
    )}
    renderBuyRow={(order) => (
      <>
        <td className={`${styles['text-mono']} ${styles.num}`}>{formatCurrency(order.limit_price, order.currency_code ?? order.scheme.currency)}</td>
        <td className={`${styles['text-mono']} ${styles.num}`}>{fmt(order.max_holding)}%</td>
        <td className={`${styles['text-mono']} ${styles.num}`}>{formatCurrency(order.min_order_val, order.scheme.currency)}</td>
        <td className={`${styles['text-mono']} ${styles.num}`}>{pair(order.cl1, order.cl2)}</td>
        <td className={`${styles['text-mono']} ${styles.num}`}>{pair(order.increase_to_1, order.increase_to_2)}</td>
        <td className={`${styles['text-mono']} ${styles.num}`}>{pair(order.increment_max_1, order.increment_max_2)}</td>
        <td className={`${styles['text-mono']} ${styles.num}`}>{pair(order.increase_by_1, order.increase_by_2)}</td>
        <td><span className={styles['method-cell']}>{order.buy_method_display ?? '—'}</span></td>
      </>
    )}
    renderSellRow={(order) => (
      <>
        <td className={`${styles['text-mono']} ${styles.num}`}>{pair(order.h1, order.h2)}</td>
        <td className={`${styles['text-mono']} ${styles.num}`}>{pair(order.condition_1, order.condition_2)}</td>
        <td className={`${styles['text-mono']} ${styles.num}`}>{formatCurrency(order.min_order_val, order.scheme.currency)}</td>
        <td><span className={styles['method-cell']}>{order.sell_method_display ?? '—'}</span></td>
      </>
    )}
  />
);

export default ProcessedInstructions;